import PropTypes from 'prop-types';
import ThemeProvider from 'react-bootstrap/ThemeProvider';

import bsComponentPrefixes from './bs-component-prefixes.json';
import globals from '../../../utils/globals';

const prefixes = bsComponentPrefixes.reduce((map, bsPrefix) => {
  map[bsPrefix] = `${globals.CSS_PREFIX}${bsPrefix}`;
  return map;
}, {});

/**
 * Component used to provide and prefix global styles. Including this component in the styleguide adds the global styles to the page.
 * Note that styles are not prefixed in the styleguide build, so this component is not required to correctly prefix bootstrap components in the styleguide.
 */
const ThemeProviderCustom = props => {
  return <ThemeProvider prefixes={prefixes} {...props} />;
};

ThemeProviderCustom.propTypes = {
  children: PropTypes.node
};

export default ThemeProviderCustom;
